module.exports = __webpack_public_path__ + "img/research-analyst-2.e303a5c2.svg";